import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import {
  ImpersonateDialogData,
  ImpersonateDialogResult,
} from '../../../Interfaces/impersonate-dialog.interface';

@Component({
  selector: 'app-impersonate-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, MatIconModule, TranslateModule],
  templateUrl: './impersonate-dialog.component.html',
  styleUrl: './impersonate-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImpersonateDialogComponent {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _dialogRef =
    inject<MatDialogRef<ImpersonateDialogComponent, ImpersonateDialogResult>>(MatDialogRef);

  readonly data = inject<ImpersonateDialogData>(MAT_DIALOG_DATA);

  readonly formGroup: FormGroup = this._formBuilder.group({
    reason: ['', [Validators.maxLength(255)]],
  });

  confirm(): void {
    if (!this.formGroup.valid) {
      return;
    }

    const reason = String(this.formGroup.value.reason ?? '').trim();

    this._dialogRef.close({ reason: reason === '' ? null : reason });
  }

  cancel(): void {
    this._dialogRef.close();
  }
}
